import React from "react";
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import About from "./About";
import Home from "./Home";
import Contact from './Contact';
import Products from './Products';
import SingleProduct from './SingleProduct';
import Cart from './Cart';
import ErrorPage from './ErrorPage';
import { GlobalStyle } from "./GlobalStyle";
import { ThemeProvider } from "styled-components";
import Header from "./components/Header";
import Footer from "./components/Footer";



const App = () => {
const theme={
  colors:{
    heading:"rgb(24, 24, 29)",
    text:"rgba(29, 29, 29, 0.8)",
    white:"#fff",
    black:"#212529",
    helper:"#8490ff",

    bg:"#F6F8FA",
    footer_bg:"#0a1435",
    btn:"rgb(98, 84, 243)",
    border:"rgba(98, 84, 243, 0.5)",
    hr:"#ffffff",
    gradient:"linear-gradient(0deg, rgba(132 , 144, 255) 0%, rgb(98, 189,252) 100%)",
    shadow:
    "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
    shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
  },

  media:{
    mobile:"768px",
    tab:"998px",
  },
};

  return (
    <ThemeProvider theme={theme}>
    <BrowserRouter>
    {/* included it here so that all routes can access the id's and classes of this globalstyle component */}
    <GlobalStyle />
    <Header />
    <Routes>
      <Route path="/" element={<Home />}/>
      <Route path="/about" element={<About /> }/>
      <Route path="/contact" element={<Contact /> }/>
      <Route path="/products" element={<Products /> }/>
      {/* we need to pass id of product to view it in singlepage */}
      <Route path="/singleproduct/:id" element={<SingleProduct /> }/>
      <Route path="/cart" element={<Cart /> }/>
      {/* agar upar wale routes ke alaa koi bhi route hoga then we will show error */}
      <Route path="*" element={<ErrorPage /> }/>
    </Routes>
    <Footer />
    </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
